import React from 'react';
import Icon from '../../../components/AppIcon';

const GameStats = ({ stats }) => {
  return (
    <div className="game-stats-container w-full">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        <div className="stat-card bg-card border-2 border-primary rounded-sm p-4 md:p-6 shadow-glow-cyan-sm">
          <div className="flex flex-col items-center gap-2">
            <Icon name="Flame" size={24} color="var(--color-warning)" />
            <span className="text-xs md:text-sm font-caption text-muted-foreground tracking-wide">STREAK</span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-data text-warning">{stats?.currentStreak}</span>
          </div>
        </div>

        <div className="stat-card bg-card border-2 border-accent rounded-sm p-4 md:p-6 shadow-glow-green-sm">
          <div className="flex flex-col items-center gap-2">
            <Icon name="Gem" size={24} color="var(--color-accent)" />
            <span className="text-xs md:text-sm font-caption text-muted-foreground tracking-wide">GEMS</span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-data text-accent">{stats?.gemsEarned}</span>
          </div>
        </div>

        <div className="stat-card bg-card border-2 border-secondary rounded-sm p-4 md:p-6 shadow-glow-magenta-sm">
          <div className="flex flex-col items-center gap-2">
            <Icon name="Target" size={24} color="var(--color-secondary)" />
            <span className="text-xs md:text-sm font-caption text-muted-foreground tracking-wide">ROUND</span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-data text-secondary">{stats?.currentRound}</span>
          </div>
        </div>

        <div className="stat-card bg-card border-2 border-error rounded-sm p-4 md:p-6 shadow-glow-magenta-sm">
          <div className="flex flex-col items-center gap-2">
            <Icon name="Zap" size={24} color="var(--color-error)" />
            <span className="text-xs md:text-sm font-caption text-muted-foreground tracking-wide">DIFFICULTY</span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-data text-error">{stats?.difficultyLevel}</span>
          </div>
        </div>
      </div>
      <div className="mt-4 md:mt-6 bg-card border border-primary/30 rounded-sm p-3 md:p-4">
        <div className="flex items-center justify-between text-xs md:text-sm font-caption">
          <div className="flex items-center gap-2">
            <Icon name="Trophy" size={16} color="var(--color-accent)" />
            <span className="text-muted-foreground">WINS:</span>
            <span className="text-accent font-data">{stats?.wins}</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="X" size={16} color="var(--color-error)" />
            <span className="text-muted-foreground">LOSSES:</span>
            <span className="text-error font-data">{stats?.losses}</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Percent" size={16} color="var(--color-primary)" />
            <span className="text-muted-foreground">WIN RATE:</span>
            <span className="text-primary font-data">{stats?.winRate}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameStats;